import { css } from 'aphrodite';
import React from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../components/Checkbox';
import { TrashIcon } from '../../../../../components/svgs/icons/TrashIcon';
import { styleSheet } from '../../styles';
import { DEFAULT_VALUES, IFormValues } from './types';

interface PreviewGuestFieldsProps {
	guestLimit: number;
	requireGuestNames?: boolean; // Not used in preview but kept for API compatibility
}

export const PreviewGuestFields: React.FC<PreviewGuestFieldsProps> = ({ guestLimit }) => {
	const { control, watch, setValue } = useFormContext<IFormValues>();

	const { fields, append, remove } = useFieldArray({
		control,
		name: 'guests',
	});

	const formValues = watch();
	const bringingGuest = formValues.bringingGuest || false;

	const handleBringingGuestChange = React.useCallback(() => {
		const toggle = !bringingGuest;
		if (!toggle) {
			setValue('guests', DEFAULT_VALUES.guests);
		}
		setValue('bringingGuest', toggle);
	}, [bringingGuest, setValue]);

	return (
		<div className={css(styleSheet.plusOneOptionWrap)}>
			<div className={css(styleSheet.formControl)}>
				<Controller
					name='bringingGuest'
					control={control}
					render={({ field: { ref, ...fieldProps } }) => (
						<Checkbox
							checked={fieldProps.value}
							className={css(styleSheet.checkbox)}
							id='bringingGuest'
							name='bringingGuest'
							onChange={handleBringingGuestChange}
						>
							<div className={css(styleSheet.bringingGuestsLabel)}>I&apos;ll be bringing a guest</div>
						</Checkbox>
					)}
				/>
			</div>
			{bringingGuest ? (
				<>
					{fields.map((item, index) => (
						<div key={item.id} className={css(styleSheet.guestInfo)}>
							<div className={css(styleSheet.formControl)}>
								<label htmlFor={`client-guest-${index}-first-name`} className={css(styleSheet.label)}>
									Guest First Name:
								</label>
								<input
									id={`client-guest-${index}-first-name`}
									className={`text-input ${css(styleSheet.textInput)}`}
									type='text'
									placeholder='Optional PREVIEW ONLY'
									disabled
								/>
							</div>
							<div className={css(styleSheet.formControl)}>
								<label htmlFor={`client-guest-${index}-last-name`} className={css(styleSheet.label)}>
									Guest Last Name:
								</label>
								<input
									type='text'
									id={`client-guest-${index}-last-name`}
									className={`text-input ${css(styleSheet.textInput)}`}
									placeholder='Optional PREVIEW ONLY'
									disabled
								/>
							</div>
							<button
								className={css(styleSheet.removeGuest)}
								onClick={() => {
									remove(index);
									if (!index && formValues.guests.length === 1) {
										// If the last guest is removed, reset the bringingGuest and guests fields
										setValue('bringingGuest', false);
										setValue('guests', DEFAULT_VALUES.guests);
									}
								}}
								type='button'
							>
								<TrashIcon className={css(styleSheet.removeGuestIcon)} />
							</button>
						</div>
					))}
					{guestLimit > fields.length ? (
						<button
							type='button'
							className={css(styleSheet.addAnotherGuestButton)}
							onClick={() => {
								append({ firstName: '', lastName: '', isPaid: false });
							}}
						>
							+ Add another guest
						</button>
					) : null}
				</>
			) : null}
		</div>
	);
};
